$(document).ready(function(){
	/*Header slider*/
	var owlHeaderSlider = $(".displayTopColumn .htmlcontent__container");
	owlHeaderSlider.owlCarousel({
		items: 1,
		nav: false,
		dots:  owlHeaderSlider.children().length > 1,
		dotsSpeed: 1000,
		autoplay: true,
		autoplaySpeed: 1000,
		loop:  owlHeaderSlider.children().length > 1,
		navText:	['<i class="font-left-open-big">','<i class="font-right-open-big">']
	});
	/*index page*/
	$(".js-carousel-products").each(function(){
		var owlProductsIndex = $(this);
			owlProductsIndex.owlCarousel({
			items: 4,
			nav: false,
			dots: owlProductsIndex.children().length > 1,
			autoplay: true,
			loop: owlProductsIndex.children().length > 1,
			responsiveClass:true,
			responsive:{
				0:{
					items:1
				},
				480:{
					items:2
				},
				768:{
					items:3
				},
				991:{
					items:4
				}
			},
			navText:	['<i class="font-left-open-big">','<i class="font-right-open-big">']
		});
	});
	var owlBrands = $('#htmlcontent_displayHome .htmlcontent__container');
	owlBrands.owlCarousel({
		items: 5,
		nav: false,
		dots: false,
		autoplay: true,
		loop: owlBrands.children().length > 1,
		responsiveClass:true,
		responsive:{
			0:{
				items:1
			},
			480:{
				items:3
			},
			768:{
				items:4
			},
			991:{
				items:5
			},
			1200:{
				items:5
			}
		},
		navText:	['<i class="font-left-open-big">','<i class="font-right-open-big">']
	});
	/*product page*/
	var owlProducts = $('.js-carousel-productscategory,.js-carousel-accessories');
	owlProducts.owlCarousel({
		items: 5,
		nav: false,
		dots: true,
		autoplay: true,
		loop: owlProducts.children().length > 1,
		responsiveClass:true,
		responsive:{
			0:{
				items:1
			},
			480:{
				items:2
			},
			768:{
				items:3
			},
			991:{
				items:4
			}
		},
		navText:	['<i class="font-left-open-big">','<i class="font-right-open-big">']
	});
});


// WEBPACK FOOTER //
// ./js/components/carousels.js